<template>
  <div>
  <v-list class="member-list" flat>
    <v-list-item-group>
      <v-list-item v-for="(item, i) in searchList" :key="i">
        <v-list-item-icon @click="$emit('clickMemberItem', item)">
          <v-avatar>
            <img v-if="getImgSrc(item) !== ''" :src="getImgSrc(item)" alt="employees.name" />
          </v-avatar>
        </v-list-item-icon>

        <v-list-item-content @click="$emit('clickMemberItem', item)">
          <v-list-item-title class="d-flex justify-space-between">
            <div>
              <span class="name" v-text="item.empName"></span>
              <span class="divider position" v-text="item.jikweeNm"></span>
            </div>
          </v-list-item-title>
          <v-list-item-subtitle>
            <span class="position" v-text="item.orgNm"></span>
          </v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-icon class="btn-wrap">

          <v-btn
            v-if="item.contPhone != null && !isShowEmployeeDialogBtn"
            color="#eaebec"
            elevation="0"
            width="40"
            min-width="40"
            height="40"

            target="_parent"
            @click="callSms(item.contPhone.replace(/-/g, ''))"
          >
            <v-icon size="18">mdi-message-processing-outline</v-icon>
          </v-btn>

          <v-btn
            v-if="item.contPhone != null"
            color="#eaebec"
            elevation="0"
            width="40"
            min-width="40"
            height="40"

            target="_parent"
            @click="callTel(item.contPhone.replace(/-/g, ''))"
          >
            <!--<v-icon size="18">mdi-phone-outline</v-icon>-->
            <v-icon size="25">mdi-cellphone-basic</v-icon>
          </v-btn>

          <v-btn
            v-if="item.contOffice !== null"
            color="#eaebec"
            elevation="0"
            width="40"
            min-width="40"
            height="40"

            target="_parent"
            @click="callTel(item.contOffice.replace(/-/g, ''))"
          >
            <v-icon size="18">mdi-phone-classic</v-icon>
          </v-btn>

          <v-btn
              v-if="isShowEmployeeDialogBtn"
              color="#eaebec"
              elevation="0"
              width="40"
              min-width="40"
              height="40"

              target="_parent"
              @click="openEmployeeRd(item)"
          >
            <v-icon size="18" color="#363c43">mdi-account-details-outline</v-icon>
          </v-btn>
        </v-list-item-icon>
      </v-list-item>
    </v-list-item-group>
  </v-list>
  
  <v-dialog v-if="isShowEmployeeDialog" v-model="isShowEmployeeDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card height="100%">
        <v-toolbar fixed flat>
          <v-btn icon @click="isShowEmployeeDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn icon @click="firstPage">
            <v-icon>mdi-arrow-collapse-left</v-icon>
          </v-btn>
          <v-btn icon @click="prevPage">
            <v-icon>mdi-arrow-left-bold-circle</v-icon>
          </v-btn>
          <v-btn icon @click="nextPage">
            <v-icon>mdi-arrow-right-bold-circle</v-icon>
          </v-btn>
          <v-btn icon @click="lastPage">
            <v-icon>mdi-arrow-collapse-right</v-icon>
          </v-btn>
          <v-btn icon @click="zoomIn">
            <v-icon>mdi-magnify-plus-outline</v-icon>
          </v-btn>
          <v-btn icon @click="zoomOut">
            <v-icon>mdi-magnify-minus-outline</v-icon>
          </v-btn>
        </v-toolbar>
        <div id="crownix-viewer" style="width : 100%; margin-top : 44px;"></div>
      </v-card>
    </v-dialog>
  
  </div>
</template>

<script>
/* 직원정보목록 컴포넌트 */
import {loadScript} from "vue-plugin-load-script"; // ** dialog Mixin **
import {encryptEmployee} from "@/api/rd";

export default {
  props: {
    searchList: {
      type: Array,
    },
  },
  data: () => ({
    viewer : null,
    isShowEmployeeDialog : false,
    isShowEmployeeDialogBtn : false
  }),
  computed: {
    // getImgSrc() {
    //   return item => {
    //     return item.bFileNm !== null
    //       ? this.$domain + 'api/file/profile?fileName=' + item.bFileNm + '&enterCd=' + item.enterCd
    //       : /*
    //         this.$domain +
    //           '/cloudhr/1.0/file/display?fileId=' +
    //           item.fileId +
    //           '&seqNo=' +
    //           item.seqNo
    //         */
    //         require('@/assets/img/profile_none.png');
    //   };
    // },
  },

  methods: {
    callSms(num) {
      window.bizMOB.System.callSMS({
        "_aNumber" : [num],
        "_sMessage" : "",
        "_fCallback" : function(res) {
          // console.log('callSms : '+JSON.stringify(res));
        }
      });
    },

    callTel(num) {
      window.bizMOB.System.callTEL({
        "_sNumber" : num,
        "_fCallback" : function(res) {
          // console.log(JSON.stringify(res));
        }
      });
    },

    getImgSrc(item){
      return (item.bFileNm !== null && item.bFileNm !== '')
          ? this.$domain + 'api/file/profile?fileName=' + item.bFileNm + '&enterCd=' + item.enterCd
          : '';
    }

    , empInfoCardYnChk(){
      if (this.$store.getters.GET_USER_DATA.empInfoCardYn == 'Y') {
        this.isShowEmployeeDialogBtn = true; // 대표, HR, 시스템담당자
      }
    }
    
    , openEmployeeRd(info){
      if(!this.$store.getters.GET_SECOND_AUTHENTICATE){
        this.$store.commit('SET_SECOND_AUTHENTICATE_AFTER_TYPE', 'dialog');
        this.$store.commit('SET_SHOW_SECOND_AUTHENTICATE', true);
        return;
      }
      this.isShowEmployeeDialog = true;
      this.loadCrownix(info);
    }
    , loadCrownix(info){
      loadScript(
          process.env.VUE_APP_RD_URL + '/ReportingServer/html5/js/crownix-viewer.min.js',
          //'https://mhr.bgf.co.kr/ReportingServer/html5/js/crownix-viewer.min.js',
      ).then((e) => {
        // console.log('crownix loaded');
        this.getEncrypt(info);
      });
    }
    , getEncrypt(info){
      encryptEmployee({
        enterCd : info.enterCd
        , sabun : info.sabun
        , fileName : info.bFileNm
        , parameterType : ''
        , localCd : ''
      }).then((response) => {
        this.viewer = new window.m2soft.crownix.Viewer(
            process.env.VUE_APP_RD_URL + '/ReportingServer/service',
            //'https://mhr.bgf.co.kr/ReportingServer/service',
            'crownix-viewer',
        );
        this.viewer.setParameterEncrypt(11);
        this.viewer.openFile(response.data.path, response.data.encryptParameter, {showPageNum : 2});
        this.viewer.hideToolbar();
      });
    }
    , firstPage(){
      this.viewer.moveFirstPage();
    }
    , prevPage(){
      this.viewer.prevPage();
    }
    , nextPage(){
      this.viewer.nextPage();
    }
    , lastPage(){
      this.viewer.moveLastPage();
    }
    , zoomIn(){
      this.viewer.zoomIn();
    }
    , zoomOut(){
      this.viewer.zoomOut();
    }
  },
  mounted() {
    this.empInfoCardYnChk();
  },
};
</script>

<style>
.crownix-dialog-message:nth-child(2){
  display: block !important;
  position:absolute;
  top:70px;
}
.crownix-dialog-message:nth-child(3){
  display: none !important;
}
</style>
